import React, { PropsWithChildren } from 'react';

import gfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';

type LinkRendererProps = PropsWithChildren<any> & {
    href: string;
};

const LinkRenderer: React.FC<LinkRendererProps> = ({ href, children }: LinkRendererProps) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
    </a>
);

interface MarkdownProps {
    text: string;
}

export const Markdown: React.FC<MarkdownProps> = ({ text }: MarkdownProps) => (
    <ReactMarkdown plugins={[gfm]} renderers={{ link: LinkRenderer }}>
        {text.replace(/\\{1,2}n/gi, '  \n')}
    </ReactMarkdown>
);
